// extracted by mini-css-extract-plugin
export default {"imageContainer":"ContentfulBackgroundImage-module__imageContainer--tIqLC","expandFalse":"ContentfulBackgroundImage-module__expandFalse--YUuvf"};